import { connect } from 'react-redux';
import {
  logout,
  changeSection,
  changeScreen,
  getUser,
  updateInViewMenuItem,
} from '@actions';
import AppTopbar from './AppTopbar';

const mapStateToProps = (state) => {
  return {
    user: state.api.user,
    policy: state.api.policy,
    isToggled: state.menu.mobileToggled,
    language: state.api.language.selected,
    menu: state.menu.items,
    ready: state.menu.initialized,
    active: state.menu.active,
    event: state.api.event.data,
    currency: state.api.event.data.currencySymbol,
    itemsInView: state.menu.itemsInView,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUser: () => dispatch(getUser()),
  logout: () => dispatch(logout(true)),
  changeSection: (section) => dispatch(changeSection(section)),
  changeScreen: (section) => dispatch(changeScreen(section)),
  updateInViewMenuItem: (key, status) =>
    dispatch(updateInViewMenuItem(key, status)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AppTopbar);
